import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { Sidebar } from '@/components/layout/Sidebar';
import { TopBar } from '@/components/layout/TopBar';
import { RightPanel } from '@/components/layout/RightPanel';
import { BottomNav } from '@/components/layout/BottomNav';
import { AdvisorFab, AdvisorDrawer } from '@/components/AdvisorDrawer';
import { ToolRail } from '@/components/layout/ToolRail';

export const AppLayout = () => {
  const { authed, companyId } = useApp();
  if (!authed || !companyId) return <Navigate to="/login" replace />;

  return (
    <div className="app-shell min-h-screen relative">
      <div className="app-shell-bg pointer-events-none fixed inset-0 z-0" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/finpulse-bg.jpg)` }} />
      <div className="app-shell-overlay pointer-events-none fixed inset-0 z-0" />
      <div className="app-shell-grid pointer-events-none fixed inset-0 z-0 opacity-60" />
      <div className="relative z-10">
        <Sidebar />
        <TopBar />
        <RightPanel />
        <ToolRail />
        <main className="lg:ml-[232px] xl:mr-[356px] pt-16 min-h-screen">
          <div className="p-4 sm:p-6 lg:p-8 pb-28 lg:pb-10">
            <Outlet />
          </div>
        </main>
        <BottomNav />
        <AdvisorFab />
        <AdvisorDrawer />
      </div>
    </div>
  );
};
